import "./App.css";
import "./style/rightside.css";
import "./style/index.css";
import "./style/login.css";
import "./style/main.css";
import "./style/slider.css";
import {
    Route,
    Navigate,
    Outlet,
    Routes,
    useLocation,
    useNavigationType,
    createRoutesFromChildren,
    matchRoutes,
} from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import React, { Suspense, useCallback, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { checkAutoLogin } from "./store/authServices";
import { clearClientAuth } from "./store/action";
import Dashboard from "./pages/dashboard/Dashboard";
import FinanceHome from "./pages/finance/Finance";
import Finance from "./pages/finance/invoice";
import CreateInvoice from "./pages/finance/CreateInvoice";
import SetupInvoice from "./pages/finance/SetupInvoice";
import UploadInvoiceCreate from "./pages/finance/UploadInvoiceCreate";
import LetterOfcreditType from "./letter_of_credit/home";
import TransactionDetails from "./letter_of_credit/ansaction_detail";
import ChooseBank from "./letter_of_credit/bank";
import Summary from "./letter_of_credit/summary";
import TradeofCredit from "./trade_of_credit/TradeOfCredit";
import TradeofCreditType from "./trade_of_credit/type";
import TradeDocument from "./trade_of_credit/document";
import TradeSummary from "./trade_of_credit/summary";
import TradeInventory from "./trade_of_credit/inventory";
import Goods from "./trade_of_credit/goods";
import Cashflow from "./trade_of_credit/cashflow";
import CustomerDetails from "./trade_of_credit/customers";
import FlexHome from "./component/flex/FlexHome";
import SelectCardtype from "./component/flex/card/SelectCardtype";
import CreateCard from "./component/flex/card/CreateCard";
import Swal from "sweetalert2";
import ShareInvoice from "./component/flex/share/ShareInvoice";
import FlexInvoiceFlex from "./component/flex/FlexInvoiceFlex";
import FlexInvoceSuccess from "./component/flex/FlexInvoceSuccess";
import AccountHome from "./account/home";
import TopUp from "./topup/home";
import BusinessProfile from "./profile/business";
import PurchaseOrder from "./trade_of_credit/purchaseorder";
import PurchaseOrderDocument from "./trade_of_credit/PurchaseOrderDocument";
import CreditLine from "./letter_of_credit/newhome";
import CreditLineDocument from "./letter_of_credit/newdocument";
import EditFlexInvoice from "./component/flex/EditFlexInvoice";
import RepayLoan from "./pages/finance/repay";
import TopupType from "./topup/TopupType";
import CardPaymentTopUp from "./topup/card";
import InvoicePreview from "./pages/finance/InvoicePreview";
import InvicePreviewDocument from "./pages/finance/InvoicePreviewDocument";
import Amount from "./topup/amount";
import CreatePurchaseOrder from "pages/flex/Procurement/CreatePurchaseOrder";
import Loading from "component/loading";
import CreateShipment from "pages/flex/shipment/CreateShipment";
import AddShipmentDetails from "component/flex/shipments/AddShipmentDetails";
import Flex from "pages/flex/Flex";
import * as Sentry from "@sentry/react";
import ScrollToTop from "component/ScrollToTop";
import EmailVerification from "pages/auth_v2/EmailVerification";
import Auth from "pages/auth_v2/Auth";
import CreateNewPassword from "pages/auth_v2/CreateNewPassword";
import useInactivityTimeout from "hooks/useInactivityTimeout";
import { analytics } from "./firebase/firebase";
import "./utilities/errorTracking";
import { logEvent } from "firebase/analytics";
import ErrorBoundary from "./component/ErrorBoundary";
import RecoverPassword from "pages/auth_v2/RecoverPassword";
import BusinessDetails from "pages/auth_v2/onboarding/BusinessDetails";
import ContactDetails from "pages/auth_v2/onboarding/ContactDetails";
import AddDirectors from "pages/auth_v2/onboarding/AddDirectors";
import ControlPerson from "pages/auth_v2/onboarding/ControlPerson";
import SoleProprietorshipDocuments from "pages/auth_v2/onboarding/SoleProprietorshipDocuments";
import LLCDocuments from "pages/auth_v2/onboarding/LLCDocuments";
import BusinessVerificationWallets from "pages/auth_v2/onboarding/BusinessVerificationWallets";
import OnboardingSummary from "pages/auth_v2/onboarding/OnboardingSummary";
import UpdateInformation from "pages/auth_v2/onboarding/UpdateInformation";
import SuccessfullyUpdatedOnboarding from "pages/auth_v2/onboarding/SuccessfullyUpdatedOnboarding";

import SignIn from "pages/auth_v2/signin/SignIn";
import Confirm2FA from "pages/auth_v2/signin/Confirm2FA";
import SignUp from "pages/auth_v2/signup/SignUp";
import ActivateAccount from "pages/auth_v2/ActivateAccount";
import PinSetup from "pages/auth_v2/PinSetup";
import Setup2FA from "pages/auth_v2/2FA/Setup2FA";
import BackupVerification from "pages/auth_v2/2FA/BackupVerification";
import CurrencyConverter from "pages/wallet/CurrencyConverter";
import SendMoney from "pages/pay/send-money/SendMoney";
import SameCurrencyTradevuUser from "pages/pay/send-money/same-currency/SameCurrencyTradevuUser";
import CrossBorderTradevuUser from "pages/pay/send-money/cross-border/CrossBorderTradevuUser";
import SameCurrencyOtherUsers from "pages/pay/send-money/same-currency/SameCurrencyOtherUsers";
import CrossBorderOtherUsers from "pages/pay/send-money/cross-border/CrossBorderOtherUsers";
import RecipientDetails from "pages/pay/send-money/RecipientDetails";
import PaymentInformation from "pages/pay/send-money/PaymentInformation";
import ReviewPaymentDetails from "pages/pay/send-money/ReviewPaymentDetails";
import Wallets from "./pages/wallet/Wallets";
import BillPayment from "./pages/bill_payment/BillPayment";
import InvoicePage from "./pages/invoice_v2/Invoice";
import ManageInvoice from "./pages/invoice_v2/manage-invoice/ManageInvoice";
import CreateInvoiceV2 from "./pages/invoice_v2/create-invoice/CreateInvoice";
import FinanceRequest from "./pages/finance/v2/FinanceRequest";
import Credit from "./pages/finance/v2/Finance";
import ManageFinance from "./pages/finance/v2/ManageFinance";
import History from "./pages/finance/v2/History";
import CryptoToFiatTransfer from "./pages/pay/send-money/crypto-currency/CryptoToFiatTransfer";
import CryptoWalletTransfer from "./pages/pay/send-money/crypto-currency/CryptoWalletTransfer";
import PreviewDomiciliation from "./pages/finance/v2/PreviewDomiciliation";
import AcceptDomiciliation from "./pages/finance/v2/AcceptDomiciliation";
import BusinessContact from "./pages/auth_v2/update-kyc/BusinessContact";
import BusinessInformation from "./pages/auth_v2/update-kyc/BusinessInformation";
import UpdateKYC from "./pages/auth_v2/update-kyc/UpdateKYC";
import PartnerTosIframeModal from "./component/wallet/PartnerTosModal";
import CryptoConverter from "./pages/wallet/CryptoConverter";

Sentry.init({
    dsn: process.env.REACT_APP_SENTRY_DSN,
    integrations: [
        Sentry.reactRouterV6BrowserTracingIntegration({
            useEffect: React.useEffect,
            useLocation,
            useNavigationType,
            createRoutesFromChildren,
            matchRoutes,
        }),
    ],
    tracesSampleRate: 1.0,
    environment: process.env.REACT_APP_STAGE,
});

const SentryRoutes = Sentry.withSentryReactRouterV6Routing(Routes);

function App() {
    const { isLogin } = useSelector((state) => state);
    const [isCheckingLogin, setIsCheckingLogin] = useState(true);
    const location = useLocation();

    const dispatch = useDispatch();

    const handleInactivityLogout = useCallback(() => {
        const lastPath = window.location.pathname;
        sessionStorage.clear();
        clearClientAuth(dispatch);
        sessionStorage.setItem("lastVisitedPath", lastPath);
        window.location.href = "/auth/signin?timeout=true";
    }, [dispatch]);

    // 30 minutes = 1800000 milliseconds
    useInactivityTimeout(1800000, handleInactivityLogout);

    useEffect(() => {
        if (!navigator.onLine) {
            Swal.fire({
                text: "Please check your internet connection",
                icon: "error",
                confirmButtonText: "Cancel",
                width: "280px",
                confirmButtonColor: "crimson",
            });
        }
    }, []);
    useEffect(() => {
        logEvent(analytics, "page_view", {
            page_location: window.location.href,
            page_path: location.pathname,
        });
    }, [location]);

    useEffect(() => {
        checkAutoLogin(dispatch).finally(() => {
            setIsCheckingLogin(false);
        });
    }, [dispatch]);

    if (isCheckingLogin) {
        // Show a loader while checking login status
        return <Loading />;
    }

    return (
        <ErrorBoundary>
            <Suspense fallback={<Loading />}>
                <ScrollToTop />
                <SentryRoutes>
                    {/* Redirect "/" based on auth state */}
                    <Route
                        path="/"
                        element={
                            isLogin ? (
                                <Navigate to="/dashboard" replace />
                            ) : (
                                <Navigate to="/auth/signin" replace />
                            )
                        }
                    />
                    <Route element={<PrivateRoutes loggedIn={isLogin} />} path="/">
                        <Route element={<FinanceHome />} path="finance/home" />
                        <Route element={<FinanceHome />} path="finance/history" />
                        <Route element={<Finance />} path="finance/invoice" />
                        <Route element={<FinanceRequest />} path="/finance/credit/request" />
                        <Route element={<Credit />} path="/finance/credit" />
                        <Route element={<History />} path="finance/credit/history" />
                        <Route element={<ManageFinance />} path="finance/credit/:id" />
                        <Route element={<SetupInvoice />} path="finance/setupinvoice" />
                        <Route element={<UploadInvoiceCreate />} path="finance/uploadinvoice/:id" />
                        <Route element={<CreateInvoice />} path="finance/CreateInvoice" />
                        <Route element={<LetterOfcreditType />} path="letter_of_credit/type" />
                        <Route element={<CreditLine />} path="creditline/home" />
                        <Route
                            element={<TransactionDetails />}
                            path="letter_of_credit/transaction_details/:id"
                        />
                        <Route element={<ChooseBank />} path="letter_of_credit/bank" />
                        <Route element={<TradeofCredit />} path="trade_of_credit/home" />
                        <Route element={<TradeofCreditType />} path="trade_of_credit/type/:id" />
                        <Route element={<TradeDocument />} path="trade_of_credit/shipping/:id" />
                        <Route element={<TradeSummary />} path="trade_of_credit/summary" />
                        <Route element={<TradeInventory />} path="trade_of_credit/inventory/:id" />
                        <Route element={<Goods />} path="trade_of_credit/goods/:id" />
                        <Route element={<PurchaseOrder />} path="trade_of_credit/purchase/:id" />
                        <Route element={<PurchaseOrderDocument />} path="purchase/document" />
                        <Route element={<Cashflow />} path="trade_of_credit/cashflow/:id" />
                        <Route element={<EditFlexInvoice />} path="flex/edit" />
                        <Route element={<InvoicePage />} path="invoice" />
                        <Route element={<ManageInvoice />} path="invoice/manage/:id" />
                        <Route element={<CreateInvoiceV2 />} path="invoice/create-invoice" />
                        <Route element={<CreditLineDocument />} path="letter_of_credit/document" />
                        <Route element={<Summary />} path="letter_of_credit/summary" />
                        <Route element={<CustomerDetails />} path="trade_of_credit/customer" />
                        <Route element={<Flex />} path="flex/home" />
                        <Route element={<Flex />} path="flex/home/:tab" />
                        <Route element={<FlexHome />} path="flex/home/old" />
                        <Route element={<SelectCardtype />} path="card/get_started" />
                        <Route element={<CreateCard />} path="card/create_card/:id" />
                        <Route element={<RepayLoan />} path="loan/repayment" />
                        <Route element={<ShareInvoice />} path="flex/shareInvoice" />
                        <Route element={<FlexInvoiceFlex />} path="flex/invoice" />
                        <Route element={<FlexInvoceSuccess />} path="flex/success" />
                        <Route element={<AccountHome />} path="account/home" />
                        <Route element={<BusinessProfile />} path="profile/switch" />
                        <Route element={<TopUp />} path="topup/payment_link" />
                        <Route element={<TopupType />} path="topup/home" />
                        <Route element={<CardPaymentTopUp />} path="topup/card" />
                        <Route element={<InvoicePreview />} path="invoice/preview" />
                        <Route element={<Amount />} path="topup/fund" />
                        <Route element={<CurrencyConverter />} path="convert-currency" />
                        <Route element={<CryptoConverter />} path="convert-crypto" />
                        <Route element={<Dashboard />} path="dashboard" />
                        {/* send crypto */}
                        <Route path="payment/send-crypto">
                            <Route path="crypto-wallet/amount" element={<CryptoWalletTransfer />} />
                            <Route path="fiat-wallet/amount" element={<CryptoToFiatTransfer />} />
                            <Route
                                path="crypto-wallet/recipient-info"
                                element={
                                    <RecipientDetails nextRoute="/payment/send-crypto/crypto-wallet/payment-info" />
                                }
                            />
                            <Route
                                path="fiat-wallet/recipient-info"
                                element={
                                    <RecipientDetails nextRoute="/payment/send-crypto/fiat-wallet/payment-info" />
                                }
                            />
                            <Route
                                path="crypto-wallet/payment-info"
                                element={
                                    <PaymentInformation nextRoute="/payment/send-crypto/crypto-wallet/review-payment-details" />
                                }
                            />
                            <Route
                                path="fiat-wallet/payment-info"
                                element={
                                    <PaymentInformation nextRoute="/payment/send-crypto/fiat-wallet/review-payment-details" />
                                }
                            />
                            <Route
                                path="crypto-wallet/review-payment-details"
                                element={<ReviewPaymentDetails />}
                            />
                            <Route
                                path="fiat-wallet/review-payment-details"
                                element={<ReviewPaymentDetails />}
                            />
                        </Route>
                        {/* send money */}
                        <Route path="payment/send-money" element={<SendMoney />}>
                            <Route
                                path="same-currency/tradevu-user/amount"
                                element={<SameCurrencyTradevuUser />}
                            />
                            <Route
                                path="cross-border/tradevu-user/amount"
                                element={<CrossBorderTradevuUser />}
                            />
                            <Route
                                path="same-currency/bank-recipient/amount"
                                element={<SameCurrencyOtherUsers />}
                            />
                            <Route
                                path="cross-border/bank-recipient/amount"
                                element={<CrossBorderOtherUsers />}
                            />

                            <Route
                                path="same-currency/tradevu-user/recipient-info"
                                element={
                                    <RecipientDetails nextRoute="/payment/send-money/same-currency/tradevu-user/payment-info" />
                                }
                            />
                            <Route
                                path="cross-border/tradevu-user/recipient-info"
                                element={
                                    <RecipientDetails nextRoute="/payment/send-money/cross-border/tradevu-user/payment-info" />
                                }
                            />
                            <Route
                                path="same-currency/bank-recipient/recipient-info"
                                element={
                                    <RecipientDetails nextRoute="/payment/send-money/same-currency/bank-recipient/payment-info" />
                                }
                            />
                            <Route
                                path="cross-border/bank-recipient/recipient-info"
                                element={
                                    <RecipientDetails nextRoute="/payment/send-money/cross-border/bank-recipient/payment-info" />
                                }
                            />

                            <Route
                                path="same-currency/tradevu-user/payment-info"
                                element={
                                    <PaymentInformation nextRoute="/payment/send-money/same-currency/tradevu-user/review-payment-details" />
                                }
                            />
                            <Route
                                path="cross-border/tradevu-user/payment-info"
                                element={
                                    <PaymentInformation nextRoute="/payment/send-money/cross-border/tradevu-user/review-payment-details" />
                                }
                            />
                            <Route
                                path="same-currency/bank-recipient/payment-info"
                                element={
                                    <PaymentInformation nextRoute="/payment/send-money/same-currency/bank-recipient/review-payment-details" />
                                }
                            />
                            <Route
                                path="cross-border/bank-recipient/payment-info"
                                element={
                                    <PaymentInformation nextRoute="/payment/send-money/cross-border/bank-recipient/review-payment-details" />
                                }
                            />

                            <Route
                                path="same-currency/tradevu-user/review-payment-details"
                                element={<ReviewPaymentDetails />}
                            />
                            <Route
                                path="cross-border/tradevu-user/review-payment-details"
                                element={<ReviewPaymentDetails />}
                            />
                            <Route
                                path="same-currency/bank-recipient/review-payment-details"
                                element={<ReviewPaymentDetails />}
                            />
                            <Route
                                path="cross-border/bank-recipient/review-payment-details"
                                element={<ReviewPaymentDetails />}
                            />
                        </Route>
                        <Route
                            element={<InvicePreviewDocument />}
                            path="invoice/preview/doucument"
                        />
                        <Route element={<CreatePurchaseOrder />} path="flex/create-po" />
                        <Route element={<CreateShipment />} path="flex/shipments/create" />
                        <Route element={<AddShipmentDetails />} path="flex/shipments/add-details" />
                        <Route element={<Wallets />} path="wallets" />
                        <Route element={<BillPayment />} path="bill-payments" />
                        <Route path="onboarding/update-information" element={<UpdateInformation />} />
                        <Route path="onboarding/successfully-updated" element={<SuccessfullyUpdatedOnboarding />} />
                    </Route>

                    {/* onboarding */}
                    <Route path="onboarding">
                        <Route path="business-details" element={<BusinessDetails />} />
                        <Route path="contact-details" element={<ContactDetails />} />
                        <Route path="add-directors" element={<Navigate to="business-ownership/directors" replace />} />
                        <Route
                            path="business-ownership/control-person"
                            element={<ControlPerson />}
                        />
                        <Route path="business-ownership/directors" element={<AddDirectors />} />
                        <Route
                            path="business-verification/compliance/llc"
                            element={<LLCDocuments />}
                        />
                        <Route
                            path="business-verification/compliance/soleproprietorship"
                            element={<SoleProprietorshipDocuments />}
                        />
                        <Route
                            path="business-verification/wallets"
                            element={<BusinessVerificationWallets />}
                        />
                        <Route path="summary" element={<OnboardingSummary />} />
                        <Route path="successfully-updated" element={<SuccessfullyUpdatedOnboarding />} />
                    </Route>

                    <Route element={<PublicRoutes loggedIn={isLogin} />}>
                        <Route path="/auth" element={<Auth />}>
                            <Route index element={<Navigate to="/auth/signin" replace />} />
                            <Route path="signin" element={<SignIn />} />
                            <Route path="confirm-2fa" element={<Confirm2FA />} />
                            <Route path="2fa-backup" element={<BackupVerification />} />
                            <Route path="signup" element={<SignUp />} />
                            <Route path="verify-email" element={<EmailVerification />} />
                            <Route path="create-new-password" element={<CreateNewPassword />} />
                            <Route path="recover-password" element={<RecoverPassword />} />
                            <Route path="activate-account" element={<ActivateAccount />} />
                            <Route path="update-kyc-details" element={<UpdateKYC />} />
                            <Route path="tos-aggrement" element={<PartnerTosIframeModal />} />
                            <Route path="setup-pin" element={<PinSetup />} />
                            <Route path="setup-2fa" element={<Setup2FA />} />
                        </Route>
                        <Route
                            element={<PreviewDomiciliation />}
                            path="/preview-domiciliation/:id"
                        />
                        <Route element={<AcceptDomiciliation />} path="/accepted-domiciliation" />
                        <Route element={<AcceptDomiciliation />} path="/actions/domiciliation" />
                    </Route>

                    <Route path="update-kyc">
                        <Route path="control-person" element={<BusinessContact />} />
                        <Route path="additional-information" element={<BusinessInformation />} />
                    </Route>

                    <Route element={<CreatePurchaseOrder />} path="/create-po/:poId" />

                    <Route path={"*"} element={<Navigate to="/dashboard" replace />} />
                </SentryRoutes>
            </Suspense>
        </ErrorBoundary>
    );
}

const PrivateRoutes = ({ loggedIn }) => {
    const location = useLocation();

    if (!loggedIn) {
        const path = `${location.pathname}${location.search || ""}`;
        if (path && path !== "/") {
            sessionStorage.setItem("lastVisitedPath", path);
        }
        return <Navigate to={"/auth/signin"} replace />;
    }

    return <Outlet />;
};
const PublicRoutes = ({ loggedIn }) => {
    const location = useLocation();

    // Check if the current path is either "/" (login) or "/register" (signup)
    if (
        loggedIn &&
        [
            "/auth/signin",
            "/auth/signin/confirm-2fa",
            "/auth/2fa-backup",
            "/auth/signup",
            "/auth/recover-password",
            "/auth/create-new-password",
        ].includes(location.pathname)
    ) {
        return <Navigate to={"/dashboard"} replace />;
    }

    return <Outlet />;
};

export default App;
